import moment from "moment";
export const convertBytesintoKb = (value) => {
    const temp = Math.floor(value / 1024);
    return temp;
};
export const convertKbintoMb = (value) => {
    const temp = Math.floor(value / 1024);
    return temp;
};
export const convertMbToKb = (value) => {
    const temp = Math.floor(value * 1024);
    return temp;
};

export const AMPED_APPLICATION_CHARGE = 1.5;

// currency.js (or any relevant file)
export const currencyHTMLCode = '&#8377;';

// User Name get Two Letter
export const extractInitials = (fullName) => {
    if (fullName != '') {
        const initials = fullName.split(" ");
        var strTwoCharacters = '';
        if (initials && initials.length === 1) {
            strTwoCharacters = initials[0].slice(0, 2).toUpperCase();
        } else if (initials && initials.length > 1) {
            strTwoCharacters = initials.slice(0, 2).map((word) => word.charAt(0).toUpperCase()).join("");
        }

        return strTwoCharacters;
    } else { return null; }
};

// Return Year List 10Past Or 21Future Year
export const getYearListForSelectBoxOption = () => {
    const currentYear = new Date().getFullYear();
    const pastYears = 1;
    const futureYears = 30;

    const yearListArray = [];
    for (let i = currentYear - pastYears; i <= currentYear + futureYears; i++) {
        yearListArray.push({ value: i, label: String(i) });
    }

    return yearListArray
}

export const DateFormat = (isoString) => {
    const date = moment(isoString).format('DD-MMM-YYYY');
    return date;
}

export function calculateDistance(lat1, lng1, lat2, lng2) {
    const R = 6371; // Radius of the earth in km
    const dLat = (lat2 - lat1) * (Math.PI / 180);
    const dLng = (lng2 - lng1) * (Math.PI / 180);
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) *
        Math.sin(dLng / 2) * Math.sin(dLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c; // Distance in km
    return distance;
}

export function calculateExclusiveGST(baseAmount, gstRate) {
    const amount = parseFloat(baseAmount);
    const rate = parseFloat(gstRate);
 
    if (isNaN(amount) || isNaN(rate)) return 0;
 
    const gstAmount = (amount * rate) / 100;
    return parseFloat(gstAmount.toFixed(2));
}


export function calculateGSTAmount(totalAmount, gstRate) {
    const amount = parseFloat(totalAmount);
    const rate = parseFloat(gstRate);

    if (!amount || !rate) return 0;

    const basePrice = (amount * 100) / (100 + rate);
    const gstAmount = amount - basePrice;

    console.log({ amount, rate, basePrice, gstAmount });

    return parseFloat(gstAmount.toFixed(2));
}


export const generateRandomString = (length) => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
};

export const GOOGLE_MAP_API_KEY =
    process.env.REACT_APP_GOOGLE_MAP_API_KEY || "AIzaSyD8jtZwnsMH665_i9Y5vmuSIqYVhrL7Lx4";
export const RAZORPAY_KEY_ID =
    process.env.REACT_APP_RAZORPAY_KEY_ID || "";

export const mapStyles = [
    {
        featureType: "poi.school",
        stylers: [{ visibility: "off" }],
    },
    {
        featureType: "poi.place_of_worship",
        stylers: [{ visibility: "off" }],
    },
    {
        featureType: "poi.medical",
        stylers: [{ visibility: "off" }],
    },
    {
        featureType: "poi.business",
        stylers: [{ visibility: "off" }],
    },
    {
        featureType: "poi.attraction",
        stylers: [{ visibility: "off" }],
    },
];

export const formatTime = (isoString) => {
    const date = new Date(isoString);
    let hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    const minutesStr = minutes < 10 ? '0' + minutes : minutes;
    return `${hours}:${minutesStr} ${ampm}`;
}

export function getRelativeDate(dateString) {
    const inputDate = new Date(dateString);
    const now = new Date();

    // Normalize both dates to ignore time
    const input = new Date(inputDate.getFullYear(), inputDate.getMonth(), inputDate.getDate());
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    const diffTime = today - input;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 0) return "Today";
    if (diffDays === 1) return "Yesterday";
    if (diffDays < 0) return "in the future";
    if (diffDays >= 365) {
        const diffYears = now.getFullYear() - inputDate.getFullYear();
        return diffYears === 1 ? "1 year ago" : `${diffYears} years ago`;
    }
    if (diffDays >= 30) {
        const diffMonths = (now.getFullYear() - inputDate.getFullYear()) * 12 + (now.getMonth() - inputDate.getMonth());
        return diffMonths === 1 ? "1 month ago" : `${diffMonths} months ago`;
    }
    return `${diffDays}Days ago`;
}


export function formatIndianAmount(amount) {
    if (amount >= 10000000) {
        return (amount / 10000000).toFixed(amount % 10000000 === 0 ? 0 : 1) + 'Cr';
    } else if (amount >= 100000) {
        return (amount / 100000).toFixed(amount % 100000 === 0 ? 0 : 1) + 'L';
    } else if (amount >= 1000) {
        return (amount / 1000).toFixed(amount % 1000 === 0 ? 0 : 1) + 'K';
    } else {
        return amount.toString();
    }
}


export const StationTypeOptionList = [
    { value: 1, label: 'Tata Power' },
    { value: 2, label: 'CCS charger Type' },
    { value: 3, label: 'CHAdeMO' },
    { value: 4, label: 'Ather Energy' },
    { value: 5, label: 'A/C charge' },
    { value: 6, label: 'DC charge' },
    { value: 7, label: 'EVgo' },
    { value: 8, label: 'Supercharger' },
    { value: 9, label: 'Type 2 connectors' },
    { value: 10, label: 'Electrify America' },
    { value: 11, label: 'GBT connector' },
    { value: 12, label: 'Level 1 charging' },
    { value: 13, label: 'Magenta chargegrid' },
    { value: 14, label: 'Tata charging station' },
    { value: 15, label: 'Type 2 AC' },
    { value: 16, label: 'Blink Charging' },
    { value: 17, label: 'Statiq' },
    { value: 18, label: 'Blink Charging' }
];

export const CapacityOptionList = [
    { value: 1, label: '3kW to 7kW' },
    { value: 2, label: '8kW to 70kW' },
    { value: 3, label: '25kW to 100kW' },
    { value: 4, label: '25kW to 350kW' },
    { value: 5, label: '350kW to 500kW' },
    { value: 6, label: '500kW to 800kW' },
    { value: 7, label: '800kW to 1000kW' }
];

export const StationStatusOptionList = [
    { value: "active", label: "Active", color: "#4CAF50" },
    { value: "development", label: "Development", color: "#2196F3" },
    { value: "maintenance", label: "Maintenance", color: "#FFC107" },
    { value: "inactive", label: "Inactive", color: "#F44336" }
];

export const StationUnitChargeList = [
    { value: "Per Unit Charge", label: "Per Unit Charge" },
    { value: "Discome Charge", label: "Discome Charge" },
    { value: "Premises Charge", label: "Premises Charge" },
    { value: "Operating Charge", label: "Operating Charge" },
    { value: "Transaction Charge", label: "Transaction Charge" },
    { value: "Other Charge", label: "Other Charge" }
];


export const vehicleTypeOptions = [
    { value: 1, label: 'Two Wheeler' },
    { value: 2, label: 'Car' },
    { value: 3, label: 'Transport Bus' },
    { value: 4, label: 'Commercial Vehicle' }
];

export const batteryTypeOptions = [
    { value: 1, label: 'Lithium' },
    { value: 2, label: 'Nickel-Metal Hydride Batteries' },
    { value: 3, label: 'Lead-Acid Batteries' },
    { value: 4, label: 'Ultracapacitors Batteries' }
];
export const NotificationTimeOptions = [
    { value: '01:00', label: '01:00' },
    { value: '02:00', label: '02:00' },
    { value: '03:00', label: '03:00' },
    { value: '04:00', label: '04:00' },
    { value: '05:00', label: '05:00' },
    { value: '06:00', label: '06:00' },
    { value: '07:00', label: '07:00' },
    { value: '08:00', label: '08:00' },
    { value: '09:00', label: '09:00' },
    { value: '10:00', label: '10:00' },
    { value: '11:00', label: '11:00' },
    { value: '12:00', label: '12:00' },
    { value: '13:00', label: '13:00' },
    { value: '14:00', label: '14:00' },
    { value: '15:00', label: '15:00' },
    { value: '16:00', label: '16:00' },
    { value: '17:00', label: '17:00' },
    { value: '18:00', label: '18:00' },
    { value: '19:00', label: '19:00' },
    { value: '20:00', label: '20:00' },
    { value: '21:00', label: '21:00' },
    { value: '22:00', label: '22:00' },
    { value: '23:00', label: '23:00' },
    { value: '24:00', label: '24:00' }
];
export const YearSelectOptionList = [
    { value: 2024, label: '2024' },
    { value: 2025, label: '2025' },
    { value: 2026, label: '2026' },
    { value: 2027, label: '2027' },
    { value: 2028, label: '2028' },
    { value: 2029, label: '2029' },
    { value: 2030, label: '2030' },
    { value: 2031, label: '2031' },
    { value: 2032, label: '2032' },
    { value: 2033, label: '2033' },
    { value: 2034, label: '2034' },
    { value: 2035, label: '2035' }
];
export const chargerNoOfGunOptions = [
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5' },
];
export const chargerTypeOptions = [
    { value: 'AC', label: 'AC' },
    { value: 'DC', label: 'DC' }
];
export const offerDiscountTypeOptions = [
    { value: 0, label: 'Flat' },
    { value: 1, label: 'Percentage' },
];
export const offerCategoryOptions = [
    { value: 0, label: 'Time-Based' },
    { value: 1, label: 'User Type' },
    { value: 2, label: 'Promo Code' },
    { value: 3, label: 'Recharge CashBack' }
];
export const voltageOptions = {
    AC: ["3.3kW", "7.4kW", "10kW","11kW", "22kW"],
    DC: ["15kW", "30kW", "40kW", "50kW", "60kW", "80kW","90kW","120kW","150kW","180kW","240kW","320kW"],
};

// Charger power is always shown in kW (AC and DC alike) using the stored value as-is.
export const formatChargerPower = (voltage) => {
    return voltage;
};

export const ExpenseTypeOptions = [
    { value: 1, label: 'Miscellaneous' },
    { value: 2, label: 'Energy' },
    { value: 3, label: 'Maintanance' },
];

export const requestTypeTitles = {
    1: "Request for solve problem",
    2: "Suggest an idea",
    3: "Request for release investment",
    4: "Give a task to CPO"
};

// Calculate 10% and 90%
export const stationRefundPolice = {
    platform_charge: 10,
    refund_amount: 90
}

export const urlLikeList = [
    {
        urlId: 1,
        url: '/home',
        urlLabel: 'Home',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 2,
        url: '/customerdashboard',
        urlLabel: 'Customer Dashboard',
        parentMenuId: 0,
        isCustomerUrl: true
    },
    {
        urlId: 3,
        url: '/charging_stations',
        urlLabel: 'Charging Station',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 54,
        url: '/customer-profile',
        urlLabel: 'Profile',
        parentMenuId: 0,
        isCustomerUrl: true
    },
    {
        urlId: 4,
        url: '/profile',
        urlLabel: 'Profile',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 5,
        url: '/cpo',
        urlLabel: 'CPO (Charging Point Operator)',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 6,
        url: '/partners',
        urlLabel: 'Partners',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 7,
        url: '/charging_stations/chargingstations_details',
        urlLabel: 'Station Details',
        parentMenuId: 3,
        isCustomerUrl: false
    },
    {
        urlId: 8,
        url: '/chargers',
        urlLabel: 'Chargers',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 9,
        url: '/reports',
        urlLabel: 'Reports',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 10,
        url: '/settings',
        urlLabel: 'Settings',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 11,
        url: '/chargingstationhistory',
        urlLabel: 'Charging Station History',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 12,
        url: '/',
        urlLabel: 'Home',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 13,
        url: '/users',
        urlLabel: 'Users',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 14,
        url: '/roles',
        urlLabel: 'Roles',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 15,
        url: '/rolesrequest',
        urlLabel: 'Roles Request',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 16,
        url: '/map/search-map',
        urlLabel: 'Search Map',
        parentMenuId: 0,
        isCustomerUrl: true
    },
    {
        urlId: 17,
        url: '/map/vehiclelist',
        urlLabel: 'Vehicle List',
        parentMenuId: 0,
        isCustomerUrl: true
    },
    {
        urlId: 18,
        url: '/map/morenews',
        urlLabel: 'News',
        parentMenuId: 0,
        isCustomerUrl: true
    },
    {
        urlId: 19,
        url: '/map/newdetails',
        urlLabel: 'News Details',
        parentMenuId: 0,
        isCustomerUrl: true
    },
    {
        urlId: 20,
        url: '/map/book-now',
        urlLabel: 'Charger List',
        parentMenuId: 0,
        isCustomerUrl: true
    },
    {
        urlId: 21,
        url: '/map/view-moredetails',
        urlLabel: 'Station Details',
        parentMenuId: 0,
        isCustomerUrl: true
    },
    {
        urlId: 35,
        url: '/map/schedule-view-moredetails',
        urlLabel: 'Schedule Station Details',
        parentMenuId: 0,
        isCustomerUrl: true
    },
    {
        urlId: 22,
        url: '/map/history',
        urlLabel: 'Map History',
        parentMenuId: 0,
        isCustomerUrl: true
    },
    {
        urlId: 23,
        url: '/map/viewbookingsummary',
        urlLabel: 'Map booking Summary',
        parentMenuId: 0,
        isCustomerUrl: true
    },
    {
        urlId: 24,
        url: '/map/unit-report',
        urlLabel: 'Unit Report',
        parentMenuId: 0,
        isCustomerUrl: true
    },
    {
        urlId: 25,
        url: '/map/refer-earn',
        urlLabel: 'Refer Earn',
        parentMenuId: 0,
        isCustomerUrl: true
    },
    {
        urlId: 55,
        url: '/map/rewards-collected',
        urlLabel: 'Rewards Collected',
        parentMenuId: 0,
        isCustomerUrl: true
    },
    {
        urlId: 56,
        url: '/map/schedule',
        urlLabel: 'Select Vehicle',
        parentMenuId: 0,
        isCustomerUrl: true
    },
    {
        urlId: 26,
        url: '/map/searchschedule',
        urlLabel: 'Search Schedule',
        parentMenuId: 0,
        isCustomerUrl: true
    },
    {
        urlId: 27,
        url: '/wallet',
        urlLabel: 'wallet',
        parentMenuId: 0,
        isCustomerUrl: true
    },
    {
        urlId: 28,
        url: '/station',
        urlLabel: 'Station',
        parentMenuId: 0,
        isCustomerUrl: true
    },
    {
        urlId: 29,
        url: '/transaction',
        urlLabel: 'Transaction',
        parentMenuId: 0,
        isCustomerUrl: true
    },
    {
        urlId: 30,
        url: '/map/booking_scanner',
        urlLabel: 'Booking Scanner',
        parentMenuId: 0,
        isCustomerUrl: true
    },
    {
        urlId: 31,
        url: '/map/booking_charger',
        urlLabel: 'Booking Charger',
        parentMenuId: 0,
        isCustomerUrl: true
    },
    {
        urlId: 32,
        url: '/map/booking_charger_start',
        urlLabel: 'Booking Charger Start',
        parentMenuId: 0,
        isCustomerUrl: true
    },
    {
        urlId: 33,
        url: '/map/booking_charger_stop',
        urlLabel: 'Booking Charger Stop',
        parentMenuId: 0,
        isCustomerUrl: true
    },
    {
        urlId: 34,
        url: '/map/booking_station_review',
        urlLabel: 'Booking Charger Review',
        parentMenuId: 0,
        isCustomerUrl: true
    },
    {
        urlId: 36,
        url: '/map/instant_book',
        urlLabel: 'Instant Book',
        parentMenuId: 0,
        isCustomerUrl: true
    },
    {
        urlId: 37,
        url: '/map/schedule-booking',
        urlLabel: 'ScheduleBookingEnd',
        parentMenuId: 0,
        isCustomerUrl: true
    },
    {
        urlId: 38,
        url: '/map/view-schedulebooking-summary',
        urlLabel: 'SchedulebookingSummary',
        parentMenuId: 0,
        isCustomerUrl: true
    },
    {
        urlId: 39,
        url: '/family/family_account',
        urlLabel: 'Family Account',
        parentMenuId: 0,
        isCustomerUrl: true
    },
    {
        urlId: 40,
        url: '/payment-status',
        urlLabel: 'Payment Status',
        parentMenuId: 0,
        isCustomerUrl: true
    },
    {
        urlId: 41,
        url: '/cpodashboard',
        urlLabel: 'CPO Dashboard',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 42,
        url: '/review',
        urlLabel: 'Customer Review',
        parentMenuId: 0,
        isCustomerUrl: true
    },
    {
        urlId: 43,
        url: '/offers',
        urlLabel: 'Offers',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 44,
        url: '/revenue',
        urlLabel: 'Revenue',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 45,
        url: '/expenses',
        urlLabel: 'Expenses',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 46,
        url: '/consumption',
        urlLabel: 'Cunsumption',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 47,
        url: '/busytime',
        urlLabel: 'Busy Time',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 48,
        url: '/stations',
        urlLabel: 'Stations',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 49,
        url: '/cpooffers',
        urlLabel: 'Cpo Offers',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 50,
        url: '/owner-expenses',
        urlLabel: 'Expenses',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 51,
        url: '/superadminoffers',
        urlLabel: 'Offers',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 52,
        url: '/activitylog',
        urlLabel: 'activitylog',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 53,
        url: '/offernotification',
        urlLabel: 'Offer Notification',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 57,
        url: '/partner-dashboard',
        urlLabel: 'Partner-Dashboard',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 58,
        url: '/partner-revenue',
        urlLabel: 'Revenue',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 59,
        url: '/partner-live-tracking',
        urlLabel: 'Live-tracking',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 60,
        url: '/partner-consumption',
        urlLabel: 'Consumption',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 61,
        url: '/partner-busytime',
        urlLabel: 'Partner Busytime',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 62,
        url: '/partner-landmark-view',
        urlLabel: 'Partner-Landmark-Details',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 63,
        url: '/new-properties',
        urlLabel: 'New Properties',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 64,
        url: '/approved-land-mark',
        urlLabel: 'Approved land mark',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 65,
        url: '/approved-landmark-details',
        urlLabel: 'Approved Station Details',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 66,
        url: '/revenueinvoice',
        urlLabel: 'Revenue Report',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 67,
        url: '/partner-expense-report',
        urlLabel: 'Partner Track-Expense',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 68,
        url: '/partner-elecricity-bill',
        urlLabel: 'Partner Elecricity-Bill',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 69,
        url: '/partner-raise_request',
        urlLabel: 'Partner Raise-Request',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 70,
        url: '/partner-suggetion',
        urlLabel: 'Partner Suggetion',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 71,
        url: '/associate-partners-manage',
        urlLabel: 'Associate Partners-Manage',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 72,
        url: '/partner-lead-management',
        urlLabel: 'Associate Lead-Management',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 73,
        url: '/charger-service-request',
        urlLabel: 'Charger Service-Request',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 74,
        url: '/charger-log',
        urlLabel: 'Charger Log',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 75,
        url: '/wall_balance-in_partner-view',
        urlLabel: 'WallBalance-InPartner-View',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 76,
        url: '/charger-details_view',
        urlLabel: 'Charger-Details',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 77,
        url: '/help-support',
        urlLabel: 'Help & Support',
        parentMenuId: 0,
        isCustomerUrl: false
    },
    {
        urlId: 78,
        url: 'delete-my-account',
        urlLabel: 'Delete-My-Account',
        parentMenuId: 0,
        isCustomerUrl: true
    },
    {
        urlId: 79,
        url: '/privacy-policy-view',
        urlLabel: 'Privacy Policy-View',
        parentMenuId: 0,
        isCustomerUrl: true
    },
    {
        urlId: 80,
        url: '/FAQs-view',
        urlLabel: 'FAQs View',
        parentMenuId: 0,
        isCustomerUrl: true
    },
]
